import { AceGenericFieldLayout } from '../../forms/generic-fields/AceGenericFieldLayout';
import { AceCard } from '../AceCard/AceCard';
import { useApplicationExtraInformation } from '@axo/shared/data-access/hooks/services/loan_application/useApplicationExtraInformation';
import styles from './ExtraApplicationInfoCard.module.css';
import { LenderLogoTable } from './EligibleLendersTable';
import { ApplicationConditionalWrapper } from '../ConditionalWrappers/ApplicationConditionalWrapper';
import { Product } from '@axo/shared/data-access/types';

interface ExtraApplicationInfoCardProps {
  applicationID: string;
}

export const ExtraApplicationInfoCard: React.FC<
  ExtraApplicationInfoCardProps
> = ({ applicationID }) => {
  const { data: extraInfoData } = useApplicationExtraInformation(applicationID);

  return (
    <AceCard
      id={`ExtraApplicationInfo.${applicationID}`}
      noBorder
      title="Extra Information"
      noContentPadding
      isExpandedByDefault
    >
      <div className={styles.rootContainer}>
        <div className={styles.column}>
          <AceGenericFieldLayout
            inputElement={undefined}
            valueElement={
              <strong>{extraInfoData?.LoanToValue?.toFixed(2) || '-'}</strong>
            }
            label="Loan-to-value ratio:"
          />
          <AceGenericFieldLayout
            inputElement={undefined}
            valueElement={
              <strong>
                {extraInfoData?.CurrentLoanToValue?.toFixed(2) || '-'}
              </strong>
            }
            label="Current loan-to-value ratio:"
          />
          <AceGenericFieldLayout
            inputElement={undefined}
            valueElement={
              <strong>{extraInfoData?.DebtToIncome?.toFixed(2) || '-'}</strong>
            }
            label="Debt-to-income ratio:"
          />
        </div>
        <div className={styles.column}>
          <AceGenericFieldLayout
            inputElement={undefined}
            valueElement={
              <strong>{extraInfoData?.CalculatedQuality ?? '-'}</strong>
            }
            label="Calculated loan quality:"
          />
          <AceGenericFieldLayout
            inputElement={undefined}
            valueElement={
              <strong>{extraInfoData?.AssessedQuality ?? '-'}</strong>
            }
            label="Manually assessed loan quality:"
          />
          <AceGenericFieldLayout
            inputElement={undefined}
            valueElement={
              <strong>
                {extraInfoData?.IneligibleReasons?.join(', ') || '-'}
              </strong>
            }
            label="Ineligible reasons:"
          />
        </div>
        <ApplicationConditionalWrapper
          whitelist={[
            {
              productType: [Product.SecuredLoan],
            },
          ]}
        >
          <div className={styles.fullWidth}>
            <LenderLogoTable applicationID={applicationID} />
          </div>
        </ApplicationConditionalWrapper>
      </div>
    </AceCard>
  );
};
